import styled from 'styled-components';
import { OHeroImageContentAlignment, OHeroImageImageScale } from './OHeroImage.types';

const baseVariables = {
  mediaQuery: {
    xs: '@media (min-width: 0px)',
    sm: '@media (min-width: 576px)',
    md: '@media (min-width: 768px)',
    lg: '@media (min-width: 992px)',
    xl: '@media (min-width: 1200px)',
  },
};

export const Wrapper = styled.div<{
  $contentAlignment: OHeroImageContentAlignment;
  $imageScale: OHeroImageImageScale;
}>`
  position: relative;
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--t-brand-bg-color);

  ${baseVariables.mediaQuery.md} {
    min-height: 500px;
  }

  ${baseVariables.mediaQuery.lg} {
    min-height: 600px;
  }
`;

export const ImageContainer = styled.div<{
  $imageScale: OHeroImageImageScale;
}>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  ${({ $imageScale }) =>
    $imageScale === OHeroImageImageScale.Small &&
    `
    ${baseVariables.mediaQuery.lg} {

      margin-inline: auto;
      margin-block: auto;
      position: relative;

      img {
        border-radius: var(--t-images-border-radius, 14px);
      }
    }
  `}

  ${({ $imageScale }) =>
    $imageScale === OHeroImageImageScale.Medium &&
    `
    ${baseVariables.mediaQuery.lg} {

      margin-inline: auto;
      margin-block: auto;
      position: relative;

      img {
        border-radius: var(--t-images-border-radius, 14px);
      }
    }
  `}
`;

export const ContentContainer = styled.div<{
  $contentAlignment: OHeroImageContentAlignment;
}>`
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding-block: 2rem;
  padding-inline: 1rem;
  margin-block-start: auto;
  gap: 1rem;
  color: var(--t-brand-fg-color);
  height: 100%;
  width: 100%;

  ${baseVariables.mediaQuery.md} {
    padding-block: 3rem;
    padding-inline: 2rem;
    gap: 1.5rem;
  }

  ${baseVariables.mediaQuery.lg} {
    padding-block: 4rem;
    padding-inline: 3rem;
    gap: 2rem;
    max-width: 1200px;
    margin-inline: auto;
    width: 100%;
  }

  ${({ $contentAlignment }) =>
    $contentAlignment === OHeroImageContentAlignment.Left &&
    `
    align-items: flex-start;
    text-align: left;

    ${baseVariables.mediaQuery.lg} {
      max-width: 50%;
      margin-inline-start: 0;
    }
  `}

  ${({ $contentAlignment }) =>
    $contentAlignment === OHeroImageContentAlignment.Center &&
    `
    align-items: center;
    text-align: center;
    margin-block: auto;

    ${baseVariables.mediaQuery.lg} {
      margin-inline: auto;
    }
  `}

  ${({ $contentAlignment }) =>
    $contentAlignment === OHeroImageContentAlignment.Bottom &&
    `
    align-items: flex-start;
    text-align: left;
    margin-block-start: auto;

    ${baseVariables.mediaQuery.lg} {
      align-items: center;
      text-align: center;
      max-width: 800px;
      margin-inline: auto;
    }
  `}
`;

export const BrandElementWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: inherit;
`;

export const TextBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  ${baseVariables.mediaQuery.md} {
    gap: 1.5rem;
  }
`;

export const ButtonGroup = styled.div<{ $hasSecondary: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  ${baseVariables.mediaQuery.sm} {
    flex-direction: row;
    width: auto;
  }

  ${baseVariables.mediaQuery.md} {
    gap: 1.5rem;
  }

  ${({ $hasSecondary }) =>
    !$hasSecondary &&
    `
    ${baseVariables.mediaQuery.sm} {
      width: auto;
    }
  `}
`;

export const PhotoCaptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: inherit;
  margin-block-start: 0.5rem;

  ${baseVariables.mediaQuery.md} {
    margin-block-start: 1rem;
  }
`;
